const stats = [
  { label: '建設業許可取得', value: '3業種', note: '電気・管・土木' },
  { label: '有資格者数', value: '12名', note: '各工種の専任者を配置' },
  { label: '自社倉庫', value: '約280㎡', note: '資材在庫管理・仕分けスペース' },
  { label: '保有車両', value: '8台', note: '2tトラック・ユニック等' },
];

const facilities = [
  {
    icon: 'ri-store-2-line',
    title: '自社倉庫（約280㎡）',
    detail:
      '電線・配管材・内装材等を在庫として保有。材料を常時確保することで、急な追加発注や緊急工事にも迅速に対応します。',
  },
  {
    icon: 'ri-truck-line',
    title: '専用車両8台保有',
    detail:
      '2tトラック・ユニック車・高所作業車等を自社保有。材料搬入から重量物の設置まで、外部手配なしで対応できます。',
  },
  {
    icon: 'ri-tools-fill',
    title: '専門機材の常備',
    detail:
      '電気測定器・配管工具・コア抜き機・溶接機等の専門機材を常備。機材の貸し出し待ちによる工期遅延を防ぎます。',
  },
  {
    icon: 'ri-building-4-line',
    title: '自社事務所',
    detail:
      '設計・積算・工事管理の機能を備えた自社事務所を構えています。打合せスペースも用意しており、現地確認後の即日見積も可能です。',
  },
];

const FacilitySection = () => {
  return (
    <section id="facility" className="w-full py-16 sm:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* セクションタイトル */}
        <div className="mb-12 text-center">
          <p className="text-xs font-semibold tracking-widest mb-2" style={{ color: '#2C5AA0', letterSpacing: '0.15em' }}>
            FACILITY & EQUIPMENT
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold mb-3" style={{ color: '#1A1A1A' }}>
            拠点・設備紹介
          </h2>
          <div className="mx-auto" style={{ width: '48px', height: '2px', backgroundColor: '#2C5AA0' }}></div>
        </div>

        {/* 数字スタッツ */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center py-6 px-4 rounded-lg border border-gray-200"
              style={{ backgroundColor: '#F5F7FA' }}
            >
              <div className="text-2xl sm:text-3xl font-bold mb-1" style={{ color: '#2C5AA0' }}>
                {stat.value}
              </div>
              <div className="text-sm font-semibold mb-1" style={{ color: '#1A1A1A' }}>
                {stat.label}
              </div>
              <div className="text-xs" style={{ color: '#888' }}>
                {stat.note}
              </div>
            </div>
          ))}
        </div>

        {/* 2カラム：画像＋説明 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden border border-gray-200 mb-10">
          {/* 倉庫画像 */}
          <div className="relative" style={{ minHeight: '300px' }}>
            <img
              src="https://readdy.ai/api/search-image?query=large%20organized%20construction%20materials%20warehouse%20interior%20with%20metal%20shelving%20racks%20filled%20with%20pipes%20cables%20electrical%20materials%2C%20clean%20bright%20storage%20facility%2C%20professional%20inventory%20management%2C%20industrial%20warehouse%20Japan%2C%20neatly%20arranged%20stock&width=720&height=480&seq=fac001&orientation=landscape"
              alt="自社資材倉庫の内部"
              className="w-full h-full object-cover object-top"
              style={{ minHeight: '300px' }}
            />
            <div className="absolute bottom-0 left-0 right-0 px-4 py-3" style={{ backgroundColor: 'rgba(20,30,50,0.7)' }}>
              <p className="text-white text-xs font-medium">▲ 自社資材倉庫（約280㎡）</p>
            </div>
          </div>

          {/* 事務所画像 */}
          <div className="relative" style={{ minHeight: '300px' }}>
            <img
              src="https://readdy.ai/api/search-image?query=modern%20construction%20company%20office%20building%20exterior%20with%20company%20branded%20work%20vehicles%20trucks%20parked%20in%20front%2C%20professional%20corporate%20signage%2C%20clean%20architectural%20design%2C%20suburban%20industrial%20area%20Japan%2C%20daytime%20bright%20natural%20lighting&width=720&height=480&seq=fac002&orientation=landscape"
              alt="自社事務所外観と保有車両"
              className="w-full h-full object-cover object-top"
              style={{ minHeight: '300px' }}
            />
            <div className="absolute bottom-0 left-0 right-0 px-4 py-3" style={{ backgroundColor: 'rgba(20,30,50,0.7)' }}>
              <p className="text-white text-xs font-medium">▲ 自社事務所外観・保有車両</p>
            </div>
          </div>
        </div>

        {/* 設備詳細カード */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {facilities.map((fac) => (
            <div
              key={fac.title}
              className="flex gap-4 p-5 rounded-lg border border-gray-200 bg-white"
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded flex-shrink-0"
                style={{ backgroundColor: '#EEF2FA' }}
              >
                <i className={`${fac.icon} text-lg`} style={{ color: '#2C5AA0' }}></i>
              </div>
              <div>
                <h3 className="text-sm font-bold mb-1.5" style={{ color: '#1A1A1A' }}>
                  {fac.title}
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#666' }}>
                  {fac.detail}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* 訴求ポイント */}
        <div
          className="mt-10 p-6 sm:p-8 rounded-lg border-l-4"
          style={{ backgroundColor: '#EEF2FA', borderLeftColor: '#2C5AA0' }}
        >
          <h3 className="text-base font-bold mb-2" style={{ color: '#2C5AA0' }}>
            自社倉庫保有による主なメリット
          </h3>
          <ul className="grid grid-cols-1 sm:grid-cols-3 gap-y-2 gap-x-6">
            {[
              '資材調達待ちによる工期遅延の防止',
              '資材価格変動リスクの低減',
              '緊急・追加工事への即日対応',
            ].map((item) => (
              <li key={item} className="flex items-start gap-2 text-sm" style={{ color: '#1A1A1A' }}>
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-double-line text-sm" style={{ color: '#2C5AA0' }}></i>
                </div>
                <span className="leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FacilitySection;
